import { UpdateExtraInput } from './extra.type'
import { IGQLApiError } from '../api.types'
import CommonApiError from '../errors/CommonApiError'
import proxyApiFetchClient from '../proxyApiFetchClient'
import parseHttpApiError from '../utils/parseHttpApiError'

const myUpdateExtra = async <T>(data: UpdateExtraInput<T>, authToken: string): Promise<string> => {
    try {
        const result = await proxyApiFetchClient<string>(
            '/my-update-extra/',
            {
                method: 'POST',
                jsonBody: data,
                headers: {
                    authorization: authToken,
                },
            }
        )
        return result
    } catch (err: unknown) {
        if (err instanceof CommonApiError) {
            throw parseHttpApiError(err.body as IGQLApiError[])
        }
        throw err
    }
}

export default myUpdateExtra
